{
  "id": "campaign-085",
  "name": "Moonlit Knoll",
  "seed": "campaign:85",
  "startDir": "E",
  "mowerRule": {
    "kind": "minTier",
    "tier": 0
  },
  "rows": [
    "....L__L....",
    ".%%~.__.....",
    "~%.~~__....x",
    ".~.~#__.....",
    "~L...__...L.",
    ".....__.....",
    ".i.i.__.i.i.",
    ".....__.....",
    "____________",
    "..L,.__..L..",
    "..,,h__h....",
    "...,.__....#",
    ".....__.....",
    ".....__.....",
    ".....x......",
    "S..........."
  ],
  "critters": [
    {
      "kind": "squirrel",
      "x": 2,
      "y": 7
    },
    {
      "kind": "squirrel",
      "x": 9,
      "y": 0
    },
    {
      "kind": "rabbit",
      "x": 8,
      "y": 14
    },
    {
      "kind": "squirrel",
      "x": 8,
      "y": 7
    },
    {
      "kind": "rabbit",
      "x": 1,
      "y": 10
    }
  ],
  "pickups": [
    {
      "kind": "gas",
      "x": 10,
      "y": 9
    },
    {
      "kind": "coin",
      "x": 5,
      "y": 8
    },
    {
      "kind": "coin",
      "x": 6,
      "y": 7
    },
    {
      "kind": "coin",
      "x": 1,
      "y": 3
    },
    {
      "kind": "coin",
      "x": 5,
      "y": 11
    },
    {
      "kind": "coin",
      "x": 8,
      "y": 15
    },
    {
      "kind": "coin",
      "x": 11,
      "y": 12
    },
    {
      "kind": "coin",
      "x": 0,
      "y": 11
    },
    {
      "kind": "repair",
      "x": 11,
      "y": 4
    }
  ],
  "moles": {
    "hills": 4,
    "first": 30,
    "every": 20
  },
  "generatorVersion": 3,
  "level": 85,
  "biome": "cemetery",
  "par": {
    "reel": 5509,
    "push": 5085,
    "selfPropelled": 4692,
    "tractor": 4310,
    "zeroTurn": 3108,
    "fairway": 2614
  },
  "routeTries": {
    "par": {
      "reel": 16,
      "push": 15,
      "selfPropelled": 6,
      "tractor": 0,
      "zeroTurn": 23,
      "fairway": 18
    }
  }
}
